import { render } from "./no-search-results-spellcheck-component.vue?vue&type=template&id=5d73967a"
import script from "./no-search-results-spellcheck-component.vue?vue&type=script&lang=js"
export * from "./no-search-results-spellcheck-component.vue?vue&type=script&lang=js"
script.render = render

export default script